import { IconButton, TextField, Tooltip, useTheme } from "@mui/material";
import { Container } from "./styles";
import SearchIcon from "@mui/icons-material/Search";
import useDebounce from "../../../Hooks/CustomHooks/debouncng";
import { SearchProps } from "./Props";
import { forwardRef, useImperativeHandle, useRef } from "react";

const SearchInput = forwardRef((props: SearchProps,ref) => {
  const { HelpTip, onCallBack, width='350px' } = props;
  const inputRefrence= useRef<HTMLInputElement>()
  const onDebounce = useDebounce();
  const theme = useTheme();

  useImperativeHandle(ref, () => ({
    value: inputRefrence?.current?.value,
  }));

  return (
    <Container>
      <Tooltip title={HelpTip} placement="bottom" arrow>
        <TextField
          placeholder="Search"
          size="small"
          sx={{ width: width, borderRadius: "8px" }}
          inputRef={inputRefrence}
          onChange={() => onDebounce(onCallBack)}
          InputProps={{
            endAdornment: (
              <>
                <IconButton>
                  <SearchIcon sx={{ color: theme.color?.sideMenuNewActive }} />
                </IconButton>
              </>
            ),
          }}
        />
      </Tooltip>
    </Container>
  );
});

export default SearchInput;
